import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VList,
  VBtn,
  VIcon,
  VTextField,
  VSelect,
  VGrid,
  VCard,
  VToolbar,
  VDivider,
  transitions
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VList,
    VBtn,
    VIcon,
    VTextField,
    VSelect,
    VGrid,
    VCard,
    VToolbar,
    VDivider,
    transitions
  },
})
